import React, { useCallback } from 'react';
import { ListParams } from '../../types/main';
import UserService from '../../services/UserService';
import { SelectProps } from './types';
import BaseSearchSelect from './BaseSearchSelect';


const UserField = (props: SelectProps) => {

  const defaultParams: ListParams = {
    page_size: 10,
    sort_key: 'ref.full_name_first_last',
    sort_dir: 'ASC',
  };

  const searchOptionsHandler = useCallback(async (params: ListParams) => {
    const records = await UserService.list({ ...defaultParams, ...params});

    return records.items?.map((item) => ({
      label: item.ref.full_name_first_last,
      id: item.id,
    })) || [];
  }, [defaultParams]);

  return (
    <BaseSearchSelect
      searchOptions={searchOptionsHandler}
      {...props}
    />
  );
};


export default UserField;
